import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpValueTypeEnumValueFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpValueTypeEnumValue
 */

export class ExpValueTypeEnumValueFactory {}
_ExpValueTypeEnumValueFactory = ExpValueTypeEnumValueFactory;
_defineProperty(ExpValueTypeEnumValueFactory, "FromJSON", function (json) {
  return _ExpValueTypeEnumValueFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpValueTypeEnumValueFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'label': json['label'],
    'description': json['description']
  };
});
_defineProperty(ExpValueTypeEnumValueFactory, "ToJSON", function (value) {
  return _ExpValueTypeEnumValueFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpValueTypeEnumValueFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'label': value.label,
    'description': value.description
  };
});
//# sourceMappingURL=ExpValueTypeEnumValue.js.map
